import { getFontDisplayName } from './getFontDisplayName';

export const processBaseAttributes =
  ({ variants, personalisationSlots }) =>
  (acc, { lineItemPropertyKey, selected, id }) => {
    const theSlot = personalisationSlots.get(id);

    // Skip IMAGE_UPLOAD slots - they should not be added as line item properties here.
    if (theSlot?.slotType === 'IMAGE_UPLOAD') {
      return acc;
    }

    const isTranslatedSlot = theSlot?.translatedLineItemPropertyKey;

    if (isTranslatedSlot) {
      isTranslatedSlot.split(',').forEach((key) => {
        acc[key.trim()] = selected.translatedText;
      });
    }

    let lineItemPropertyKeyValue = null;
    // If the lineItemPropertyKey is not set, return null.
    if (!lineItemPropertyKey && !isTranslatedSlot) return acc;
    // If the selected value is a variant, set the lineItemPropertyKeyValue to the product title and variant title.
    const selectedValue = Array.isArray(selected) ? selected[0] : selected;
    // Only process strings as image binaries can pass through this function.
    if (typeof selectedValue === 'string' && selectedValue?.includes('gid:/' + '/shopify/ProductVariant/')) {
      const {
        product: { title: productTitle },
        title: variantTitle
      } = variants.get(selectedValue);
      lineItemPropertyKeyValue = `${productTitle}${variantTitle !== 'Default Title' ? ` - ${variantTitle}` : ''}`;
    } else if (selectedValue && typeof selectedValue.text === 'string') {
      const fontSelection = theSlot.allowedFonts?.includes(selectedValue.font);
      // If the selected value is a text, add the word 'Product' to the lineItemPropertyKey.
      const updatedLineItemPropertyKey = `Product ${lineItemPropertyKey}`;
      // Product engraving value - font or not.
      acc[`${updatedLineItemPropertyKey}`] = selectedValue.text;

      // Product engraving font value - if there are multiple fonts.
      // Checking against specific lintItemProperty key values to determine which custom engraving font LIP is required.
      // @TODO: Consider if there's a better way to handle this.
      const fontDisplayName = getFontDisplayName({ fontName: selectedValue.font });
      if (fontSelection && updatedLineItemPropertyKey.includes('Product Personalisation Back')) {
        acc[`Custom Engraving Font Back`] = fontDisplayName;
      } else if (fontSelection && updatedLineItemPropertyKey.includes('Product Personalisation Inside')) {
        acc[`Custom Engraving Font Inside`] = fontDisplayName;
      } else if (fontSelection && updatedLineItemPropertyKey.includes('Product Personalisation')) {
        acc[`Custom Engraving Font Front`] = fontDisplayName;
      } else if (fontSelection) {
        acc[`Product Engraving Font`] = fontDisplayName;
      }

      // Return the accumulator as we've added the items.
      return acc;
    } else if (selectedValue) {
      // Otherwise, set the lineItemPropertyKeyValue to the selected value.
      lineItemPropertyKeyValue = selectedValue;
    }

    if (lineItemPropertyKeyValue !== null && lineItemPropertyKey && typeof lineItemPropertyKey === 'string') {
      acc[`${lineItemPropertyKey}`] = lineItemPropertyKeyValue;
    }
    return acc;
  };
